'use client';

import { useSyncExternalStore } from 'react';

const subscribe = (onStoreChange: () => void) => {
  document.addEventListener('visibilitychange', onStoreChange);

  return () => {
    document.removeEventListener('visibilitychange', onStoreChange);
  };
};

const getSnapshot = () => document.visibilityState === 'visible';
const getServerSnapshot = () => true;

export const usePageActivity = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
